import styled from 'styled-components';
import media from '../../constants/media';
import { H1 } from '../base/typography';

export const Wrapper = styled.div`
	position: relative;
	margin: 15rem 0 10rem 0;

	svg {
		position: absolute;
		left: -80rem;
		top: 13rem;
		z-index: -1;
	}

	${media.tablet`
		margin: 20rem 0 10rem 0;
	`};
`;

export const TileWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	background-color: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.grayLight};
	border-radius: 10px;
	padding: 5.4rem 7.1rem;
	transition: 0.2s;
	&:hover {
		transition: 0.2s;
		border: 1px solid ${({ theme }) => theme.colors.primary};
	}
`;

export const Title = styled(H1)`
	margin-bottom: 8.1rem;
	text-align: center;
	color: ${({ theme }) => theme.colors.black};
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	font-size: 6rem;
`;

export const TileTitle = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	color: ${({ theme }) => theme.colors.black};
	font-size: 3rem;
	font-weight: 700;
	align-items: center;
	margin-bottom: 2rem;
`;

export const TileDescription = styled.div`
	margin-bottom: 2rem;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 2.1rem;
	line-height: 3rem;
	color: ${({ theme }) => theme.colors.graySummary};
`;

export const TileLink = styled.a`
	margin: auto auto 0 0;
	font-size: 1.6rem;
	font-weight: 700;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	color: ${({ theme }) => theme.colors.primary};
`;

export const IconTextImage = styled.img`
	width: 4rem;
	height: 4rem;
	margin-right: 2rem;
`;
